/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighboursWallets } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const WalletsCommunities = ({ getNeighboursWallets, communityWallets, period }) => {
  useEffect(() => {
    getNeighboursWallets({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursWallets(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursWallets(payload);
  };

  return (
    <DataTable
      preset="walletsCommunities"
      data={{
        docs: communityWallets?.docs || [],
        totalPages: communityWallets?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityWallets: state.appCommunities.communityWallets,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighboursWallets: (payload) => dispatch(getNeighboursWallets(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WalletsCommunities);
